import { SaveRecipeIngredient } from '../../../../interfaces/SaveRecipeIngredient';
import { SaveRecipeIngredients } from '../../../../interfaces/SaveRecipeRequest';
import {
  RecipeFormValues,
  RecipeIngredientFormValue,
} from '../../interfaces/RecipeFormValues';

/** Builds the entry key by key - any key beyond the whitelist makes the backend fail with 500. */
const toSaveIngredient = ({
  ingredientId,
  foodId,
  amount,
  amountUnit,
  perUnit: { veggies },
}: RecipeIngredientFormValue): SaveRecipeIngredient =>
  ingredientId != null
    ? { id: ingredientId, amount, amountUnit, veggies }
    : // a new ingredient always carries a foodId - foodToIngredientFormValue sets it
      { foodId: foodId as number, amount, amountUnit, veggies };

/** Multipart body of `POST api/recipe` / `PUT api/recipe` (see `SaveRecipeRequest`). */
export const buildRecipeFormData = (values: RecipeFormValues): FormData => {
  const ingredients: SaveRecipeIngredients = { general: [], network: [] };

  values.ingredients.forEach((ingredient) => {
    ingredients[ingredient.isNetwork ? 'network' : 'general'].push(
      toSaveIngredient(ingredient),
    );
  });

  const formData = new FormData();

  if (values.id != null) {
    formData.append('id', String(values.id));
  }

  formData.append('name', values.name);
  formData.append('description', values.description || '');
  formData.append('servingSize', String(values.servingSize));
  formData.append('servingMeasurement', values.servingMeasurement);
  formData.append('amount', String(values.amount));
  formData.append('ingredients', JSON.stringify(ingredients));

  if (values.image) {
    // the backend checks the extension of this file name
    formData.append('file', values.image, values.image.name);
  }

  return formData;
};
